// This component has been autogenerated with 'generate:components' script
import type { IconProps } from 'icons/types/Icon.types'
import { DEFAULT_ICON_COLOR, DEFAULT_ICON_SIZE } from 'icons/utils/constants'
import { cx } from 'utils/cx'

import styles from 'icons/Icon.module.scss'

export const IconSustainability = ({
	alt,
	className,
	color = DEFAULT_ICON_COLOR,
	height = DEFAULT_ICON_SIZE,
	lang,
	width = DEFAULT_ICON_SIZE,
	rotateRtl,
}: IconProps): React.ReactNode => {
	const computedClassName = cx(
		styles[`icon-${color}`],
		rotateRtl && styles[`rotate-rtl`],
		className
	)

	return (
		<svg
			width={width}
			height={height}
			role='img'
			aria-hidden={!alt ? 'true' : undefined}
			className={computedClassName}
			data-testid='sustainability'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path d='M17.68 6.35A8 8 0 0 0 12.014 4C7.588 4 4 7.591 4 12.021a8 8 0 0 0 2.347 5.672 8.06 8.06 0 0 0 5.667 2.32 8.06 8.06 0 0 0 5.667-2.32 8.03 8.03 0 0 0 2.335-5.672A8.03 8.03 0 0 0 17.68 6.35m-.56 10.783a7.14 7.14 0 0 1-5.066 2.101 7.17 7.17 0 0 1-7.166-7.173c0-1.98.802-3.774 2.099-5.072a6.87 6.87 0 0 1 5.036-2.16h-.001a7.44 7.44 0 0 1 5.101 2.083l-.002-.003a7.26 7.26 0 0 1 2.094 5.112 7.26 7.26 0 0 1-2.095 5.113ZM8.906 10.03a3.56 3.56 0 0 0-1.074 2.552c0 1 .411 1.904 1.073 2.552 0 .08.08.08.16.16a5.9 5.9 0 0 0-.479 2.319v.001h.8a7.4 7.4 0 0 1 .333-1.892l-.014.052a3.3 3.3 0 0 0 1.675.48h.003l.068.001c.974 0 1.855-.398 2.49-1.04 1.742-1.76 2.381-6.865 2.381-7.025l.08-.48-.48.08c-.239-.08-5.258.48-7.016 2.24m4.555 4.544a2.68 2.68 0 0 1-1.925.814 2.67 2.67 0 0 1-1.442-.42l.01.006a12.2 12.2 0 0 1 3.483-3.96l.034-.024c.08-.08.16-.16.24-.16l-.56-.56-.16.16a13.1 13.1 0 0 0-3.562 4.078l-.034.066a2.76 2.76 0 0 1-.766-1.911c0-.782.324-1.488.845-1.992 1.28-1.28 4.78-1.92 6.059-2.08-.4 1.28-.959 4.703-2.222 5.983' />
			{alt && <title lang={lang}>{alt}</title>}
		</svg>
	)
}
